import { Event } from '~/Features/Messaging/types';

export const AdmissionCallToActionOverlayStatuses = ['disabled', 'nonApplicableLink'] as const;
export type AdmissionCallToActionOverlayStatus = (typeof AdmissionCallToActionOverlayStatuses)[number];

export class AdmissionCallToActionOverlayStatusChanged extends Event {
    public static readonly id = 'AdmissionCallToActionOverlayStatusChanged';

    constructor(
        public readonly status: AdmissionCallToActionOverlayStatus,
        public readonly newValue: boolean
    ) {
        super(AdmissionCallToActionOverlayStatusChanged.id);
    }
}
